import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { DatePipe } from "@angular/common";

import { BaseComponent, ContentService, SupportService, UserService } from "@mypxplat/xplat/core";
import { SearchContentBaseComponent } from "@mypxplat/xplat/features";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { takeUntil } from "rxjs/operators";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-search-content",
  templateUrl: "search-content.component.html",
  standalone: false,
  providers: [DatePipe],
})
export class SearchContentComponent extends SearchContentBaseComponent {
  @ViewChild("searchInput") searchInput: ElementRef;
  public modalTitle: string;
  public searchPlaceholder: string;
  public createdLabel: string;

  constructor(
    userService: UserService,
    public activeModal: NgbActiveModal,
    public supportService: SupportService,
    public contentService: ContentService,
    private translate: TranslateService,
    private datePipe: DatePipe
  ) {
    super(userService, contentService, supportService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.updateTranslations();
    // Actualizar subData de artículos cuando se cargan
    if (this.type === "articles") {
      // Observar cambios en searchResults para actualizar subData
      // Esto se manejará en el método search() del componente base
    }
  }

  private updateTranslations() {
    const typeKey = this.type === "articles" ? "search.article" : "search.video";
    this.translate.get(typeKey).subscribe((typeText: string) => {
      this.translate.get("search.find_article_or_video", { type: typeText }).subscribe((title: string) => {
        this.modalTitle = title;
      });
    });

    const placeholderKey = this.type === "articles" ? "search.search_articles_placeholder" : "search.search_videos_placeholder";
    this.translate.get(placeholderKey).subscribe((placeholder: string) => {
      this.searchPlaceholder = placeholder;
    });

    this.translate.get("search.created_label").subscribe((label: string) => {
      this.createdLabel = label;
      // Actualizar subData de artículos existentes
      if (this.searchResults && this.searchResults.length) {
        this.updateArticlesSubData();
      }
    });
  }

  private updateArticlesSubData() {
    if (this.searchResults && this.searchResults.length && this.createdLabel) {
      this.searchResults.forEach((article: any) => {
        const formattedDate = article.created_at ? this.datePipe.transform(new Date(article.created_at), "short") || "" : "";
        article.subData = [this.createdLabel + formattedDate, article.description ? article.description : null];
      });
    }
  }

  search() {
    if (this.type == "articles" && this.query) {
      this.searching = true;
      this.searchResults = undefined;
      this.supportService.searchHelpCenter(this.query).subscribe((result: any) => {
        this.searching = false;
        if (result && result.results && result.results.length) {
          this.searchResults = result.results;
          this.searchResults.sort((a, b) => {
            return moment(a.created_at) > moment(b.created_at) ? -1 : 1;
          });
          if (this.createdLabel) {
            this.updateArticlesSubData();
          }
        }
      });
    } else {
      super.search();
    }
  }

  ngAfterViewInit() {
    this.searchInput.nativeElement.focus();
  }

  selectContent(item) {
    this.activeModal.close();
    this.contentSelected.next(item);
  }
}
